import { render } from "./IconErrorConnection.vue?vue&type=template&id=c7bfc9fc"
import script from "./IconErrorConnection.vue?vue&type=script&lang=js"
export * from "./IconErrorConnection.vue?vue&type=script&lang=js"
script.render = render

export default script